import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { detailFn as _detailFn, addFn } from 'api/tool/message';
import ueditor from '@/components/ueditor';
import { topConfig, btnConfig, mustReadConfig } from './config';
import department from '@/components/department';
export default {
  props: ['category'],
  components: {
    ueditor: ueditor,
    department: department
  },
  data: function data() {
    return {
      visible: false,
      topConfig: topConfig(this),
      btnConfig: btnConfig(this),
      mustReadConfig: mustReadConfig(this),
      form: {
        name: '',
        content: '',
        type: '',
        ids: null,
        is_top: '0',
        // 默认不置顶
        must_read: '0' // 打开时 是否必读
      },

      dataRule: {
        type: [{
          required: true,
          message: this.$t('628')
        }],
        name: [{
          required: true,
          message: this.$t('867')
        }],
        content: [{
          required: true,
          message: this.$t('629')
        }],
        ids: [{
          required: true,
          message: this.$t('221')
        }]
      },
      disabled: false,
      isSelectDepTree: false
    };
  },
  methods: {
    init: function init(item) {
      var _this = this;
      this.visible = true;
      this.$nextTick(function () {
        return _this.detailFn(item);
      });
    },
    detailFn: function detailFn(item) {
      var _this2 = this;
      this.$refs.dataForm.clearValidate();
      _detailFn({
        id: item.id
      }).then(function (res) {
        if (res && res.code === 1) {
          _this2.form.name = res.data.name;
          _this2.form.type = res.data.type;
          _this2.form.is_top = res.data.is_top;
          _this2.form.must_read = res.data.must_read;
          _this2.$refs.ueditor.setHtml(res.data.content);
        }
      });
    },
    departmentHandle: function departmentHandle(val1, val2) {
      this.form.ids = _toConsumableArray(new Set(val2.flat(999999))).join('|');
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.disabled = true;
          addFn(_objectSpread(_objectSpread({}, _this3.form), {}, {
            category: _this3.category
          })).then(function (res) {
            _this3.disabled = false;
            if (res && res.code === 1) {
              _this3.visible = false;
              _this3.$emit('refreshTableList');
            }
          }).finally(function () {
            return _this3.disabled = false;
          });
        }
      });
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) this.$refs.dataForm.resetFields();
    },
    'form.type': function formType() {
      this.form.ids = null;
    }
  }
};